// For GitHub Actions. Must be no spaces around "=".
export const APP_VERSION="0.48.49"

// Period in seconds
export const CHECK_CONNECTION_PERIOD = 1500

// Max stations count
export const MAX_STATIONS_COUNT = 1000

// https://cli.vuejs.org/ru/guide/mode-and-env.html
export const DEBUG = process.env.NODE_ENV != "production"
//console.log('ENV', process.env)

export const SERVER_HOST_NAME = "gasinvest.org"
export const DEBUG_SERVER_HOST = "localhost:8080"
//export const DEBUG_SERVER_HOST_NAME = "192.168.35.64"
const DEBUG_LOCAL_SERVER_NAME = "localhost:8080"
// Detect if load from docker lockal network
const IS_LOCAL_REQUEST = window.location.hostname == "frontend"

// API path
//export const API_URL = "http://localhost:7781"
export const API_URL = DEBUG
	? `http://${DEBUG_SERVER_HOST}/api-v1`
	: IS_LOCAL_REQUEST
	? "http://api:7781"
	: `${window.location.origin}/api-v1`

// Gotify path
export const GOTIFY_URL = DEBUG
	? `http://${DEBUG_SERVER_HOST}/gotify`
	: IS_LOCAL_REQUEST
	? "http://gotify:80"
	: `${window.location.origin}/gotify`

export const DOWNLOAD_GOTIFY_URL = DEBUG
	? `http://${DEBUG_LOCAL_SERVER_NAME}/gotify.apk`
	: `${window.location.origin}/gotify.apk`

export const GOTIFY_ICONS_URL = DEBUG
	? `http://${DEBUG_LOCAL_SERVER_NAME}/img/gotify`
	: `${window.location.origin}/img/gotify`

// URL to database
export const INFLUX_DB_URL = DEBUG
	? `http://${SERVER_HOST_NAME}/flux`
	: IS_LOCAL_REQUEST
	? "http://influxdb:8086"
	: `${window.location.origin}/flux`

// Station stabilization parameters
export const STAB_PARMS = {
	I: { id: "Iout", min: 0.5, max: 100, unit: "A", name: "струм" },
	U: { id: "Uout", min: 0.5, max: 60, unit: "В", name: "напруга" },
	E: { id: "Eout", min: -3.5, max: -0.85, unit: "В", name: "потенціал" },
};

// Empty column code
export const EMPTY_COLUMN_VALUE = "____________"

// User roles, access scope
export const USER_ROLES_SCOPE = Object.freeze({
	admin: Object.freeze([
		"view_everything",
		"dispatch_stations",
		"manage_stations",
		"calibrate_stations",
		"manage_posts",
		"make_reports",
		"manage_users",
		"manage_organizations",
		"view_log",
	]),

	engineer: Object.freeze([
		"view_everything",
		"dispatch_stations",
		"manage_stations",
		"calibrate_stations",
		"manage_posts",
		"make_reports",
	]),

	manager: Object.freeze([
		"view_everything",
		"dispatch_stations",
		"manage_stations",
		"manage_posts",
		"make_reports",
	]),

	dispatcher: Object.freeze([
		"view_everything",
		"dispatch_stations",
		"make_reports",
	]),

	visitor: Object.freeze([
		"view_everything",
	]),
});

// Назви адміністративних одониць по засовчуванню
export const DEPARTMENT_TITLE = "Ланка II"
export const SECTOR_TITLE = "Ланка III"

// Початок фіксації історії змін налаштувань і паспортів станцій та КВП
export const PASSPORT_HISTORY_WRITE_BEGIN_DATE = new Date("2025-10-01")
